import React, { useContext } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

import { PureTranslator } from 'ggApp/modules/translator';
import { ToggleInput } from './formInput';

import { Section, SectionText, DivisionLabel } from './styles';

const CheckboxComponent = ({ input, meta, ...restProps }) => {
    const theme = useContext(ThemeContext);
    return <ToggleInput {...input} {...restProps} theme={theme} />;
};

/**
 * SettingsFormSection
 * This component renders cookie type section
 * with type header, description and toogle which indicates
 * if a user allows to use this cookie type.
 */
const SettingsFormSection = ({
    disabled,
    fieldName,
    headerTranslationKey,
    textTranslationKey,
    labelTranslationKey,
}) => (
    <Section>
        <DivisionLabel title={<PureTranslator tk={headerTranslationKey} />} />
        <SectionText>
            <PureTranslator tk={textTranslationKey} />
        </SectionText>
        <Field
            disabled={disabled}
            name={fieldName}
            label={<PureTranslator tk={labelTranslationKey} />}
            component={CheckboxComponent}
        />
    </Section>
);

SettingsFormSection.propTypes = {
    disabled: PropTypes.bool,
    fieldName: PropTypes.string.isRequired,
    headerTranslationKey: PropTypes.string.isRequired,
    textTranslationKey: PropTypes.string.isRequired,
    labelTranslationKey: PropTypes.string.isRequired,
};

SettingsFormSection.defaultProps = {
    disabled: false,
};

export default SettingsFormSection;
